const htmlFontSize = 100,
  viewportScale = 1,
  deviceWidth = 750,
  bodyFontSize = 16;

const docEl = document.documentElement;

function setBodyFontSize() {
  if (document.body) {
    document.body.style.fontSize = bodyFontSize + 'px';
  } else {
    document.addEventListener('DOMContentLoaded', setBodyFontSize);
  }
}

function setRemUnit() {
  const { clientWidth, clientHeight } = docEl;
  const width = Math.min(clientHeight, clientWidth);
  const rem = (width / deviceWidth) * htmlFontSize;
  docEl.style.fontSize = rem + 'px';
}

function setViewport() {
  let viewportMetaEl = document.querySelector('meta[name="viewport"]');

  if (!viewportMetaEl) {
    viewportMetaEl = document.createElement('meta');
    viewportMetaEl.setAttribute('name', 'viewport');
    document.head.appendChild(viewportMetaEl);
  }

  viewportMetaEl.setAttribute(
    'content',
    'width=device-width,user-scalable=no,initial-scale=' +
      viewportScale +
      ',maximum-scale=' +
      viewportScale +
      ',minimum-scale=' +
      viewportScale +
      ',viewport-fit=cover'
  );
}

setRemUnit();
setViewport();
setBodyFontSize();

const resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize';
window.addEventListener(resizeEvt, setRemUnit);
window.addEventListener('pageshow', function (e) {
  if (e.persisted) {
    setRemUnit();
  }
});
